import React from 'react';

const ArrowCircleDownIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={17} height={18} viewBox="0 0 17 18" fill="none" {...props}>
        <path
            d="M6 9.83333L8.5 12.3333M8.5 12.3333L11 9.83333M8.5 12.3333V5.66667M8.5 16.5C9.48491 16.5 10.4602 16.306 11.3701 15.9291C12.2801 15.5522 13.1069 14.9997 13.8033 14.3033C14.4997 13.6069 15.0522 12.7801 15.4291 11.8701C15.806 10.9602 16 9.98491 16 9C16 8.01509 15.806 7.03982 15.4291 6.12987C15.0522 5.21993 14.4997 4.39314 13.8033 3.6967C13.1069 3.00026 12.2801 2.44781 11.3701 2.0709C10.4602 1.69399 9.48491 1.5 8.5 1.5C6.51088 1.5 4.60322 2.29018 3.1967 3.6967C1.79018 5.10322 1 7.01088 1 9C1 10.9891 1.79018 12.8968 3.1967 14.3033C4.60322 15.7098 6.51088 16.5 8.5 16.5Z"
            stroke="#272560"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ArrowCircleDownIcon;
